const wx = require('weixin-js-sdk')

const plugin = {
  install (Vue) {
    Vue.prototype.$wechat = wx
    Vue.wechat = wx
  },
  $wechat: wx
}

export default plugin
export const install = plugin.install



// WEBPACK FOOTER //
// ./~/vux/src/plugins/wechat/index.js